import React, { Fragment } from 'react';
import { Tab } from '@mui/material';

import { tabPropsAreEqual } from '@homesusa/core';
import { TabsStyled, classes } from './form-panel.style';

function FormPanel({
  children,
  tabs,
  selectedTab,
  onChangeTab
}: {
  children: React.ReactNode;
  tabs: string[];
  selectedTab: number;
  onChangeTab: (value: number) => void;
}): JSX.Element {
  const tabProps = (index: number): { [key: string]: string } => {
    const id = `form-panel-tab${index}`;
    return {
      id,
      'aria-controls': `${id}--control`,
      className: classes.tabLabel
    };
  };

  return (
    <Fragment>
      <TabsStyled
        value={selectedTab}
        onChange={(_, newValue: number): void => {
          onChangeTab(newValue);
        }}
        aria-label='panel tabs'
        className={classes.root}
        TabIndicatorProps={{ className: classes.tabIndicator }}
      >
        {tabs.map((title, index) => (
          <Tab label={title} {...tabProps(index)} key={index} />
        ))}
      </TabsStyled>
      {children}
    </Fragment>
  );
}

interface TabPanelProps {
  children: React.ReactNode;
  index: number;
  selected: number;
}

function TabPanel({ index, selected, children }: TabPanelProps): JSX.Element {
  const id = `form-panel-tab${index}`;

  return (
    <div hidden={selected !== index} id={`${id}--control`} aria-labelledby={id}>
      {selected !== index ? null : children}
    </div>
  );
}

FormPanel.TabContent = React.memo(TabPanel, tabPropsAreEqual);

export { FormPanel };
